export default __webpack_public_path__ + "static/media/tattoos.c500a6a0.png";